import { gql } from '@apollo/client';

export const GET_RESOURCE_METADATA = gql`
  query GetResourceMetadata($input: GetResourceMetadataRequest!) {
    getResourceMetadata(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        download_count
        master_list_resource
      }
    }
  }
`;
